/**
 * Configuración de reCAPTCHA
 */

// Site Key de reCAPTCHA v3 para desarrollo
// Esta clave debe coincidir con la configurada en el backend
export const RECAPTCHA_SITE_KEY = '6LdQJLUrAAAAAL-QWD8DN3ok2h63qAWZRYptQDdf';


const recaptchaConfig = {
  RECAPTCHA_SITE_KEY
};

export default recaptchaConfig;
